module.exports = __webpack_public_path__ + "static/media/right-star-icon.1e88dafe.svg";